<template>
        <span v-if="comment != ''" @click="openLog(comment)" >
            <v-icon v-if="icon" :icon="icon" color="primary" class="cursor-pointer" size="x-large"/>
        </span>
        <span v-if="logBatchId != null" @click="checkFileResult(props.params.data)">
            <v-icon v-if="icon" :icon="icon" color="primary" class="cursor-pointer" size="x-large"/>
        </span>
</template>

<script setup>
    import { inject, onBeforeMount, ref } from 'vue';
    import { mdiTrayArrowDown, mdiCodeTags } from '@mdi/js';
    import { toast } from 'vue3-toastify';
    import { useLogStore } from '@/stores/logStore';
    import { useUserStore } from '@/stores/userStore';

    const props = defineProps(['params']);

    const urlWebAPI = inject('urlWebAPI');
    const translate = inject('translate');
    const logStore = useLogStore();
    const userStore = useUserStore();

    const icons = {
        mdiTrayArrowDown,
        mdiCodeTags,
    };
    const icon = ref('');
    const comment = ref('');
    const logBatchId = ref(null);

    onBeforeMount(() => {
        // VIEW LOGS
        if (!props.params.node.group && props.params.colDef.field == 'comment' && props.params.value != null && props.params.value != '' && props.params.node.rowPinned != 'bottom') {
            icon.value = icons.mdiCodeTags;
            comment.value = props.params.value;
        }

        // DOWNLOAD RESULT FILE
        if (!props.params.node.group && props.params.colDef.field == 'download' && props.params.data != null && props.params.node.rowPinned != 'bottom') {
            icon.value = icons.mdiTrayArrowDown;
            logBatchId.value = props.params.data.id;
        }
    })


    function openLog(comment) {
        comment = comment.replace(/(\r\n|\n|\r)/gm, '<br />');
        comment = formatDates(comment);
        window.dispatchEvent(new CustomEvent('jobsLogBatches:openLog', { detail: { comment } }));
    }

    function formatDates(comment) {
        let dateTimes = comment.match(/\d{4}\/\d{2}\/\d{2}\s\d{2}:\d{2}:\d{2}/g);
        let dateTimesUTC = comment.match(/\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}:\d{2} UTC :/g);

        if (dateTimes == null)
            dateTimes = [];

        if (dateTimesUTC == null)
            dateTimesUTC = [];

        dateTimes = dateTimes.concat(dateTimesUTC);

        if (dateTimes != null)
            dateTimes = dateTimes.filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });

        for (var i = 0; i < dateTimes.length; i++) {
            var cssErrorClass = '';

            if (comment.toLowerCase().indexOf('error') > -1 || comment.toLowerCase().indexOf('erreur') > -1)
                cssErrorClass = 'with-error';

            comment = comment.replace(new RegExp(`${dateTimes[i]}`, 'ig'), '<span class="log-datetime ' + cssErrorClass + '">' + dateTimes[i] + '</span>');
        }

        return comment;
    }

    function checkFileResult(rowData) {
        let data = {
            token: userStore.getUser().token,
            customerReference: rowData.customerReference,
            logBatchId: rowData.id,
        };

        $.getData(urlWebAPI + 'GetLogBatchFile', data)
            .then((files) => {
                appendFiles(files);
            })
            .catch(error => {
                logStore.log(error, 'error');
                toast.error('Error during executing GetLogBatchFile data.', {theme: 'colored'});
            });
    }

    function appendFiles(files) {
        if (files.length == 0) {
            toast.info(translate('noFilesFound', 'toast'), {theme: 'colored'});
            return;
        }

        window.dispatchEvent(new CustomEvent('jobsLogBatches:filesFound', { detail: { files } }));
    }
</script>
